import React, { MouseEvent, useState } from 'react';
import { SxStyle } from '../../../../types';
import { useStringsContext } from '../../../../contexts/strings';
import LoadingButton from '@mui/lab/LoadingButton';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { SCENE } from '../types';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import { useUserAuth } from '../../../../contexts/auth';
import { Box, Stack } from '@mui/material';
import SceneHeader from '../../../common/scene/scene-header';

const styles: SxStyle = {
  button: {
    alignSelf: 'stretch',
    ' > .MuiButton-icon': {
      margin: 0,
    },
  },
  buttonText: (theme) => ({
    [theme.breakpoints.up('md')]: {
      display: 'block',
      marginLeft: '12px',
    },
    display: 'none',
  }),
};

interface Props {
  onChangeScene: (scene: SCENE) => void;
  onSubmit: (e: MouseEvent) => void;
  isSubmitting: boolean;
  isReadOnly: boolean;
  isDisabled: boolean;
  sceneTitles: string[];
}

const SceneConfigHeader = ({
  onChangeScene,
  onSubmit,
  isSubmitting,
  isReadOnly,
  isDisabled,
  sceneTitles,
}: Props) => {
  const { strings } = useStringsContext();
  const { isSuperAdmin } = useUserAuth();
  const [currentScene, setCurrentScene] = useState(SCENE.STARTSCENE);

  const onSelectedSceneName = (event: SelectChangeEvent) => {
    const sceneTitle = event.target.value as SCENE;
    setCurrentScene(sceneTitle);
    onChangeScene(sceneTitle);
  };

  return (
    <>
      <SceneHeader title={strings.appBar.sceneConfigs}>
        <Stack direction="row" spacing={2}>
          {!isReadOnly ? (
            <Box>
              <FormControl fullWidth>
                <InputLabel>{strings.sceneConfig.scene}</InputLabel>
                <Select
                  size="small"
                  value={currentScene}
                  label={strings.sceneConfig.scene}
                  onChange={onSelectedSceneName}
                >
                  {sceneTitles
                    // Hide SPELTIPSSCENE for non super admins
                    .filter((title) => title !== SCENE.SPELTIPSSCENE || isSuperAdmin)
                    .map((title) => (
                      <MenuItem key={title} value={title}>
                        {title}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
            </Box>
          ) : null}

          <LoadingButton
            onClick={onSubmit}
            type="submit"
            variant="contained"
            color="primary"
            startIcon={<CloudUploadIcon />}
            loading={isSubmitting}
            disabled={isReadOnly || isDisabled}
            sx={styles.button}
          >
            <Box component="span" sx={styles.buttonText}>
              {strings.actions.publishChanges}
            </Box>
          </LoadingButton>
        </Stack>
      </SceneHeader>
    </>
  );
};

export default SceneConfigHeader;
